// Collapsible Section Component
class CollapsibleSection extends HTMLElement {
  /** @type {HTMLDetailsElement} */
  get details() {
    const details = this.querySelector('details');
    if (!(details instanceof HTMLDetailsElement)) throw new Error('Details element not found');
    return details;
  }

  /** @type {HTMLElement} */
  get summary() {
    const summary = this.details.querySelector('summary');
    if (!(summary instanceof HTMLElement)) throw new Error('Summary element not found');
    return summary;
  }

  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    // Listen for toggle events to update the bold state
    this.details.addEventListener('toggle', this.#handleToggle, { signal });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  /**
   * Handles the toggle event to add/remove bold styling
   */
  #handleToggle = () => {
    if (this.details.open) {
      this.summary.classList.add('is-open');
    } else {
      this.summary.classList.remove('is-open');
    }
  };
}

if (!customElements.get('collapsible-section')) {
  customElements.define('collapsible-section', CollapsibleSection);
}
